import { CALL_PRIVATE_API } from '../../middleware/api';
import credentialsGroupSchema from '../../schemas/credentialsGroup';
import { GET, POST, PUT, DELETE } from '../../constants/requestMethods';
import * as actionTypes from '../../constants/actionTypes';
import { credentialSchema } from 'js/schemas';
import Constants from '../../Constants';
import { processSearchFilters } from 'js/lib/SearchFilterUtils';
import { SearchFilterViews } from 'js/constants/visibilityFilters';

export const getCredentialsGroups = () => (dispatch) => {
  return dispatch({
    [CALL_PRIVATE_API]: {
      types: [
        actionTypes.GET_CREDENTIALS_GROUPS_REQUEST,
        actionTypes.GET_CREDENTIALS_GROUPS_SUCCESS,
        actionTypes.GET_CREDENTIALS_GROUPS_FAILURE,
      ],
      endpoint: '/data_credentials_groups',
      schema: [credentialsGroupSchema],
      requestMethod: GET,
    },
  });
};

export const getCredentialsGroup = (id) => (dispatch) => {
  return dispatch({
    [CALL_PRIVATE_API]: {
      types: [
        actionTypes.GET_CREDENTIALS_GROUP_REQUEST,
        actionTypes.GET_CREDENTIALS_GROUP_SUCCESS,
        actionTypes.GET_CREDENTIALS_GROUP_FAILURE,
      ],
      endpoint: `/data_credentials_groups/${id}`,
      schema: credentialsGroupSchema,
      requestMethod: GET,
    },
  });
};

export const getCredentialsGroupCredentialsListing = (id, page) => (dispatch) => {
  return dispatch({
    [CALL_PRIVATE_API]: {
      types: [
        actionTypes.GET_CREDENTIALS_GROUP_CREDENTIALS_REQUEST,
        actionTypes.GET_CREDENTIALS_GROUP_CREDENTIALS_SUCCESS,
        actionTypes.GET_CREDENTIALS_GROUP_CREDENTIALS_FAILURE,
      ],
      endpoint: `/data_credentials_groups/${id}/data_credentials`,
      payload: {
        page,
        per_page: Constants.LISTING_ITEMS_PER_PAGE,
      },
      schema: [credentialSchema],
      requestMethod: GET,
      requestInfo: { id },
    },
  }).then((response) => {
    return response;
  });
};

export const getCredentialsGroupCredentials = (id) => (dispatch) => {
  return dispatch({
    [CALL_PRIVATE_API]: {
      types: [
        actionTypes.GET_ALL_CREDENTIALS_GROUP_CREDENTIALS_REQUEST,
        actionTypes.GET_ALL_CREDENTIALS_GROUP_CREDENTIALS_SUCCESS,
        actionTypes.GET_ALL_CREDENTIALS_GROUP_CREDENTIALS_FAILURE,
      ],
      endpoint: `/data_credentials_groups/${id}/data_credentials`,
      schema: [credentialSchema],
      requestMethod: GET,
      requestInfo: { id },
    },
  });
};

export const addCredentialsGroup = (name, dataCredentials, credentialsType) => (dispatch) => {
  const payload = {
    name,
    data_credentials: dataCredentials,
    credentials_type: credentialsType,
  };

  return dispatch({
    [CALL_PRIVATE_API]: {
      types: [
        actionTypes.CREATE_CREDENTIALS_GROUP_REQUEST,
        actionTypes.CREATE_CREDENTIALS_GROUP_SUCCESS,
        actionTypes.CREATE_CREDENTIALS_GROUP_FAILURE,
      ],
      endpoint: '/data_credentials_groups',
      schema: credentialsGroupSchema,
      payload,
      requestMethod: POST,
    },
  });
};

export const updateCredentialsGroup = (id, info) => (dispatch) => {
  return dispatch({
    [CALL_PRIVATE_API]: {
      types: [
        actionTypes.UPDATE_CREDENTIALS_GROUP_REQUEST,
        actionTypes.UPDATE_CREDENTIALS_GROUP_SUCCESS,
        actionTypes.UPDATE_CREDENTIALS_GROUP_FAILURE,
      ],
      endpoint: `/data_credentials_groups/${id}`,
      schema: credentialsGroupSchema,
      payload: info,
      requestMethod: PUT,
      requestInfo: { id, info },
    },
  });
};

export const deleteCredentialsGroup = (id) => (dispatch) => {
  return dispatch({
    [CALL_PRIVATE_API]: {
      types: [
        actionTypes.DELETE_CREDENTIALS_GROUP_REQUEST,
        actionTypes.DELETE_CREDENTIALS_GROUP_SUCCESS,
        actionTypes.DELETE_CREDENTIALS_GROUP_FAILURE,
      ],
      endpoint: `/data_credentials_groups/${id}`,
      schema: credentialsGroupSchema,
      requestMethod: DELETE,
      requestInfo: { id },
    },
  });
};
